import da from './da';
import en from './en';
import de from './de';

export default {
    'da-DK': da,
    'en': en,
    'en-US': en,
    'de-DE': de,
    'default': en
}
